import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const routes = [
  // 首页
  {
    path: "/",
    name: "homePage",
    component: () => import("../views/homePage.vue")
  },
  // 登录页
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login.vue")
  },
  // 登录页2
  {
    path: "/login2",
    name: "login2",
    component: () => import("../views/login2.vue")
  },
  // 服务条款
  {
    path: "/termsOfService",
    name: "termsOfService",
    component: () => import("../views/termsOfService.vue")
  },
  // 隐私政策
  {
    path: "/privacyPolicy",
    name: "privacyPolicy",
    component: () => import("../views/privacyPolicy.vue")
  },
  // 设置微名片
  {
    path: "/setCards",
    name: "setCards",
    component: () => import("../views/setCards.vue")
  },
  // 我的微主页
  {
    path: "/myPage",
    name: "myPage",
    component: () => import("../views/myPage.vue")
  },
  // 我的微主页患者视角
  {
    path: "/myPage2",
    name: "myPage2",
    component: () => import("../views/myPage2.vue")
  },
  // 我的微主页  视频点击可分享页面
  {
    path: "/myPageVideoDetail",
    name: "myPageVideoDetail",
    component: () => import("../views/myPageVideoDetail.vue")
  },
  // 我的微主页文章详情
  {
    path: "/myPageArticleDetail",
    name: "myPageArticleDetail",
    component: () => import("../views/myPageArticleDetail.vue")
  },
  // 会员中心
  {
    path: "/vipCenter",
    name: "vipCenter",
    component: () => import("../views/vipCenter.vue")
  },
  // 搜索页
  {
    path: "/search",
    name: "search",
    component: () => import("../views/search.vue")
  },
  // 编辑素材页面
  {
    path: "/editMaterial",
    name: "editMaterial",
    component: () => import("../views/editMaterial.vue")
  },
  // 素材文章加入微主页
  {
    path: "/addPage",
    name: "addPage",
    component: () => import("../views/addPage.vue")
  },
  // 制作案例海报
  {
    path: "/casePoster",
    name: "casePoster",
    component: () => import("../views/casePoster.vue")
  },
  // 我的案例
  {
    path: "/myCases",
    name: "myCases",
    component: () => import("../views/myCases.vue")
  },
  // IP精选计划
  {
    path: "/IPWinnoe",
    name: "IPWinnoe",
    component: () => import("../views/IPWinnoe.vue")
  },
  // 牙医IP计划
  {
    path: "/dentistIP",
    name: "dentistIP",
    component: () => import("../views/dentistIP.vue")
  },
  // 医嘱礼包
  {
    path: "/doctorAdvice",
    name: "doctorAdvice",
    component: () => import("../views/doctorAdvice.vue")
  },
  // 图片截取组件测试
  {
    path: "/test",
    name: "test",
    component: () => import("../views/test.vue")
  },
  // 图片截取组件测试
  {
    path: "/testW",
    name: "testW",
    component: () => import("../views/testW.vue")
  },
  // 巴茨牙医助手会员支付跳转
  {
    path: "/batsBdPay",
    name: "batsBdPay",
    component: () => import("../views/batsBdPay.vue")
  }
];

const router = new Router({
  mode: "hash",
  base: "/",
  routes
});

router.beforeEach((to, from, next) => {
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js